import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

Swiper.use([Autoplay]);

export module UiSliderModule {
  export class Service {
    private static swiperInstances: Map<HTMLElement, Swiper> = new Map();
    private static breakpoint = 600; // SP breakpoint

    constructor() {
      document.addEventListener('readCompleteAction', Service.setEvent);
      window.addEventListener('resize', Service.handleResize);
    }

    public static setEvent() {
      setTimeout(() => {
        Service.handleResize();
      }, 100);

      const sliderContainers = document.querySelectorAll<HTMLElement>('.swiper-container');
      sliderContainers.forEach(sliderContainer => {
        const isMobile = window.innerWidth <= Service.breakpoint;
        const notSlide = sliderContainer.closest('.StyledSlider')?.getAttribute('data-not-slide') === 'true';

        if (isMobile && !notSlide) {
          Service.initializeSwiper(sliderContainer);
        } else {
          Service.renderItemsWithoutSwiper(sliderContainer);
        }
      });
    }


    private static handleResize() {
      const sliderContainers = document.querySelectorAll<HTMLElement>('.swiper-container');
      sliderContainers.forEach(sliderContainer => {
        const isMobileNow = window.innerWidth <= Service.breakpoint;
        const notSlide = sliderContainer.closest('.StyledSlider')?.getAttribute('data-not-slide') === 'true';

        if (isMobileNow && !notSlide) {
          if (!Service.swiperInstances.has(sliderContainer)) {
            Service.initializeSwiper(sliderContainer);
          }
        } else {
          if (Service.swiperInstances.has(sliderContainer)) {
            Service.swiperInstances.get(sliderContainer)!.destroy(true, true);
            Service.swiperInstances.delete(sliderContainer);
          }
          Service.renderItemsWithoutSwiper(sliderContainer);
          Service.clearSwiperSlideStyles(sliderContainer); // これを追加
        }
      });
    }


    private static clearSwiperSlideStyles(sliderContainer: HTMLElement) {
      const slides = Array.from(sliderContainer.querySelectorAll<HTMLElement>('.swiper-slide'));
      slides.forEach(slide => {
        slide.removeAttribute('style');
      });
    }


    private static resetSwiperSlideStyles(sliderContainer: HTMLElement) {
      const slides = Array.from(sliderContainer.querySelectorAll<HTMLElement>('.swiper-slide'));
      slides.forEach(slide => {
        slide.style.width = '';  // width プロパティをリセット
        slide.style.margin = ''; // margin プロパティをリセット
      });
    }


    private static initializeSwiper(sliderContainer: HTMLElement) {
      const swiperInstance = new Swiper(sliderContainer, {
        //slidesPerView: 1,
        //spaceBetween: 10,
        //loop: true,
        //autoplay: {
        //  delay: 5000,
        //  disableOnInteraction: false,
        //},
        spaceBetween: 20,
        slidesPerView: 2,
        loop: true,
        allowTouchMove: false,
        speed: 3000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      });
      Service.swiperInstances.set(sliderContainer, swiperInstance);
    }

    private static renderItemsWithoutSwiper(sliderContainer: HTMLElement) {
      const slides = Array.from(sliderContainer.querySelectorAll<HTMLElement>('.swiper-slide'));
      slides.forEach(slide => {
        slide.style.width = '100%';
        slide.style.margin = '0';
      });
    }
  }
}
